import React from "react";
import styles from "./Lottery.module.css";
import { useStateContext } from "../../lib/StateContext";
import { actions } from "../../lib/actions";
import { round } from "../../lib/utils";

function Lottery({ className }) {
  const [state, dispatch] = useStateContext();

  const lotteries = React.useMemo(() => {
    return state.lottery.items;
  }, [state.lottery]);

  const cashAvailable = React.useMemo(() => {
    return state.monies.cash;
  }, [state.monies]);

  const onBuyLottery = React.useCallback(
    (lottery) => {
      const chance = lottery.win;
      const blrups = Math.random() * 100;
      const completedLottery = {
        ...lottery,
        result: blrups < chance,
      };
      alert(
        completedLottery.result
          ? `Congratulations!!!, You have won ${lottery.prize}!`
          : "Oh no you lost :( :( , Try again next time"
      );
      dispatch(actions.playlottery(completedLottery));
    },
    [dispatch]
  );
  return (
    <section className={`${className || ""} ${styles.container}`}>
      <h3>Lottery </h3>
      <table className="table">
        <thead>
          <tr>
            <th>price</th>
            <th>winnings</th>
            <th>% win</th>
            <th />
          </tr>
        </thead>
        <tbody>
          {lotteries.map((lottery) => (
            <tr key={lottery.key}>
              <td>${lottery.price}</td>
              <td>${lottery.prize}</td>
              <td>{lottery.win}%</td>
              <td>
                <button
                  className="btn btn-primary"
                  disabled={lottery.price > cashAvailable}
                  onClick={() => onBuyLottery(lottery)}
                >
                  Buy
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
      <div className={styles.stats}>
        Spent: ${round(state.lottery.moneySpent)} / Made: $
        {round(state.lottery.moneyMade)}
      </div>
    </section>
  );
}

export default Lottery;
